export default __webpack_public_path__ + "static/media/icon-home.b748f3d9.svg";